/* Funnel events contain no form values. A lead requires a server-rendered success,
   the matching pending form and a recent submission. A URL flag alone is not proof. */
(function () {
  'use strict';
  var pendingKey = 'ed_pending_lead';
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
  function read(key) { try { return sessionStorage.getItem(key) || ''; } catch (e) { return ''; } }
  function save(key, value) { try { sessionStorage.setItem(key, value); } catch (e) {} }
  function remove(key) { try { sessionStorage.removeItem(key); } catch (e) {} }
  function permitted(kind) {
    var p = window.Shopify && Shopify.customerPrivacy;
    return !!(p && typeof p[kind] === 'function' && p[kind]());
  }
  function track(name, extra) {
    if (!permitted('analyticsProcessingAllowed') || typeof window.gtag !== 'function') return;
    window.gtag('event', name, Object.assign({page_location: location.origin + location.pathname}, extra || {}));
  }
  var query = new URLSearchParams(location.search);
  keys.forEach(function (key) { var value = query.get(key); if (value) save('ed_' + key, value.slice(0, 250)); });
  function isLeadForm(form) {
    return form && form.matches('form[action*="/contact"]') && form.querySelector('input[name="form_type"][value="contact"]');
  }
  function formId(form) { return form.id || 'contact_form'; }
  function leadSource(id, path) {
    if (id === 'EdProjectInquiry') return 'project_inquiry';
    if (id === 'EdFurnitureLeadForm') return 'custom_furniture_inquiry';
    if (id === 'contact-form-ask') return 'product_question';
    if (id.indexOf('edrfq-') === 0) return 'commercial_rfq';
    if (id.indexOf('edlf-') === 0) return 'inline_quote_form';
    if (path === '/pages/trade') return 'trade_application';
    if (path.indexOf('/pages/contact') === 0) return 'contact_page';
    return 'website_contact_form';
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var params = {cta_location: link.dataset.edLocation || ''};
    if (href.indexOf('tel:') === 0) track('phone_click', params);
    else if (href.indexOf('mailto:') === 0) track('email_click', params);
    else if (href.indexOf('/pages/custom-design') > -1 || href === '#project-planner' || link.dataset.edEvent === 'quote_start') track('quote_start', params);
    else if (link.dataset.edEvent) track(link.dataset.edEvent, params);
  });
  document.addEventListener('focusin', function (event) {
    var form = event.target.form;
    if (!isLeadForm(form) || form.dataset.edStarted) return;
    form.dataset.edStarted = 'true';
    track('lead_form_start', {form_id: formId(form)});
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isLeadForm(form) || !form.checkValidity() || form.dataset.edLeadPending === 'true') return;
    form.dataset.edLeadPending = 'true';
    keys.forEach(function (key) {
      var value = read('ed_' + key);
      if (!value || form.querySelector('[data-ed-attribution="' + key + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = 'contact[' + key + ']'; input.value = value;
      input.setAttribute('data-ed-attribution', key); form.appendChild(input);
    });
    save(pendingKey, JSON.stringify({form_id: formId(form), path: location.pathname, time: Date.now()}));
    track('lead_form_attempt', {form_id: formId(form)});
  }, true);
  function confirmLead() {
    var success = document.querySelector('[data-ed-lead-success]');
    if (!success) {
      var tradeSuccess = document.querySelector('.ed-td__fm .ed-td__ok');
      if (tradeSuccess && /^thank you\b/i.test((tradeSuccess.textContent || '').trim())) success = tradeSuccess;
    }
    if (!success) success = document.querySelector('.form-ask__success[data-message]');
    if (!success || (!success.getClientRects().length && !success.matches('.form-ask__success[data-message]'))) return;
    var pending; try { pending = JSON.parse(read(pendingKey) || 'null'); } catch (e) { return; }
    if (!pending || pending.path !== location.pathname || !pending.time || Date.now() - pending.time > 1800000) return;
    var enclosingForm = success.closest('form');
    var successId = success.getAttribute('data-ed-lead-success') || (enclosingForm && formId(enclosingForm));
    if (successId && pending.form_id !== successId) return;
    remove(pendingKey);
    track('generate_lead', {form_id: pending.form_id, lead_source: leadSource(pending.form_id, pending.path)});
    var ads = success.getAttribute('data-ed-ads-conversion');
    if (ads && permitted('marketingAllowed') && typeof window.gtag === 'function') window.gtag('event', 'conversion', {send_to: ads});
    if (success.focus) success.focus({preventScroll: true});
  }
  function ready() {
    if (window.Shopify && Shopify.loadFeatures && !Shopify.customerPrivacy) {
      Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) { if (!error) confirmLead(); });
    } else confirmLead();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
